import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
        },
        searchInputGroup: {
            width: '100%',
            maxWidth: remCalc(570),
        },
        searchInput: {
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.default',
            height: 'medium.lg',
            _focus: {
                border: ' large',
                boxShadow: 'none',
            },
        },
        helpTextGap: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(24),
        },
        searchSuggestions: {
            flexDir: 'column',
            padding: 'medium.base',
            justifyContent: 'center',
            alignItems: 'center',
        },
        searchInputPlaceholder: {
            color: 'text.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        inputClearButton: {
            appearance: 'none',
            display: 'none',
        },
        buttonModalStack: {
            alignItems: 'flex-start',
            gap: remCalc(10),
            flexWrap: 'wrap',
        },
        modalOverlay: {background: 'background.overlay-modal'},
        modalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingY: '0',
            paddingX: {base: 'small.base', md: '0'},
        },
        modalContent: {
            w: {base: '100%', lg: remCalc(926)},
            maxWidth: '100%',
            paddingY: ['medium.base', 'medium.small', 'medium.md', 'medium.lg'],
            paddingInline: {md: 'small.base', lg: 'medium.lg'},
            gap: {base: 'medium.base', lg: 'medium.lg'},
            background: 'background.default',
            margin: '0',
            borderRadius: {base: 0, lg: 'large.lg'},
            maxHeight: '100%',
            minHeight: {base: '100%', lg: 'auto'},
        },
        modalBody: {
            display: 'flex',
            paddingY: '0',
            paddingX: {base: 'small.base', md: '0'},
            flexDirection: 'column',
            gap: {base: 'medium.base', lg: 'medium.lg'},
        },
        quickLinksStack: {
            gap: {base: 'small.base', lg: 'small.lg'},
            paddingBottom: 'small.lg',
        },
        trendingStack: {
            gap: {base: 'small.base', lg: 'small.lg'},
        },
        quickLinksTitle: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
        },
        productImage: {
            boxSize: {base: remCalc(141), lg: remCalc(109)},
            minW: {lg: remCalc(109)},
            marginX: 'auto',
        },
        productGrid: {
            overflowY: 'scroll',
            height: 'fit-content',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        },
        scrollContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'xsmall.base',
            maxHeight: '100%',
            overflowY: 'auto',
        },
        productDetails: {
            flexDirection: {base: 'column', lg: 'row'},
            gap: 'small.base',
            paddingRight: remCalc(12),
            borderRight: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        productName: {
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
        },
        pricingAlignment: {
            textAlign: {base: 'start', lg: 'end'},
            gap: {base: 'xxsmall.base', lg: remCalc(12)},
        },
        productdGrid: {
            templateColumns: 'repeat(2, 1fr)',
            gap: `${remCalc(40)} ${remCalc(12)}`,
        },
        productsTitleButton: {
            gap: {base: 'large.base', lg: 'small.lg'},
        },
        namePricing: {
            gap: 'xsmall.base',
        },
        closeIcon: {
            boxSize: {base: 'iconsSize.large', lg: 'iconsSize.xlarge'},
        },
        logo: {
            width: {base: `${remCalc(109)}`, lg: `${remCalc(120)}`},
            height: {base: `${remCalc(36)}`, lg: `${remCalc(56)}`},
            cursor: 'pointer',
        },
        rightElement: {
            cursor: 'pointer',
            height: '100%',
        },
        popoverContent: {
            width: '100%',
            // maxWidth: remCalc(570),
        },
        spellingMessageGap: {
            pt: remCalc(2),
        },
    },
    variants: {
        productSearch: {
            searchInputGroup: {
                maxWidth: 'unset',
            },
            container: {
                width: '100%',
            },
            searchInput: {
                paddingLeft: 'small.base',
            },
            rightElement: {
                marginRight: 'xxsmall.base',
            },
        },
        modalSearch: {
            searchInputGroup: {
                maxWidth: 'unset',
            },
            searchSuggestions: {
                position: 'absolute',
                background: 'background.default',
                w: '100%',
                padding: '0',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.secondary',
                alignItems: 'flex-start',
                maxHeight: remCalc(160),
                overflowY: 'auto',
                overflowX: 'hidden',
                zIndex: 'dropdown',
                justifyContent: 'flex-start',
                sx: {
                    '&::-webkit-scrollbar': {
                        width: remCalc(6),
                    },
                    '&::-webkit-scrollbar-track': {
                        borderRadius: 'medium.base',
                        background: 'background.light',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        borderRadius: remCalc(6.5),
                        background: 'button.border.inverse-primary-focused',
                    },
                },
            },
            suggestionText: {
                textStyle: 'body-xxsmall',
                fontWeight: 'inherit',
            },
            suggestionButton: {
                padding: `${remCalc(14)} ${remCalc(10)}`,
                color: 'text.secondary',
                justifyContent: 'flex-start',
                fontWeight: 'normal',
                sx: {
                    '&:not(:last-child)': {
                        borderBottom: 'small',
                        borderStyle: 'solid',
                        borderColor: 'border.light',
                    },
                    '&:hover': {
                        bg: 'background.light',
                        color: 'text.default',
                        fontWeight: 'bold',
                    },
                    '&:focus-visible': {
                        bg: 'background.light',
                        color: 'text.default',
                        fontWeight: 'bold',
                        boxShadow: 'outline',
                    },
                },
            },
            suggestionsContainer: {
                marginX: 0,
                width: '100%',
                flexDirection: 'column',
            },
            searchHStack: {
                padding: `${remCalc(8)} 0`,
            },
            modalSuggestions: {
                position: 'absolute',
                background: 'white',
                top: '100%',
                left: '0',
                width: '100%',
                zIndex: 'popover',
                height: 'auto',
                tabIndex: '-1',
                maxHeight: remCalc(160),
                justifyContent: 'center',
                alignItems: 'center',
            },
            popoverContent: {
                width: 'full',
                border: 'unset',
                marginTop: remCalc(-8),
            },
        },
        faqSearch: {
            container: {
                maxWidth: remCalc(570),
            },
            spellingMessageGap: {
                pt: remCalc(24),
            },
        },
    },
    parts: [
        'container',
        'searchInputGroup',
        'searchInput',
        'searchSuggestions',
        'searchInputPlaceholder',
        'searchHStack',
        'modalSuggestions',
        'suggestionsContainer',
        'suggestionButton',
        'suggestionText',
        'inputClearButton',
        'buttonModalStack',
        'modalOverlay',
        'modalHeader',
        'modalContent',
        'modalBody',
        'quickLinksStack',
        'trendingStack',
        'quickLinksTitle',
        'productImage',
        'productGrid',
        'scrollContainer',
        'productDetails',
        'productName',
        'pricingAlignment',
        'productdGrid',
        'productsTitleButton',
        'namePricing',
        'closeIcon',
        'logo',
        'rightElement',
        'popoverContent',
        'spellingMessageGap',
    ],
}
